import { render, staticRenderFns } from "./DefaultChart.vue?vue&type=template&id=d6840392&scoped=true&"
import script from "./DefaultChart.vue?vue&type=script&lang=ts&"
export * from "./DefaultChart.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultChart.vue?vue&type=style&index=0&id=d6840392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6840392",
  null
  
)

export default component.exports